import { render } from "./Header.vue?vue&type=template&id=dcb67c10&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=dcb67c10&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb67c10"]])

export default __exports__